import Image from "~/components/Image";
import {Pagination, Table} from "antd";
import PopperUserInfo from "~/components/PopperUserInfo";
import StatusLabel from "~/components/StatusLabel";
import {
	renderDate,
	numberFormat
} from "~/utils";
import FormSalaryAction from "./FormSalaryAction";

function FormSalaryTable({items = [], pagination, onPaginationChange, setItemEdit, openModal}) {

	const handleEditClick = (item) => {
		setItemEdit(item);
		openModal('addEdit');
	}

	const handleDeleteClick = (item) => {
		setItemEdit(item);
		openModal('delete');
	}

	const handleInfoClick = (item) => {
		setItemEdit(item);
		openModal('info');
	}

	const columns = [
		{ title: 'Mã đơn', dataIndex: 'code', key: "code", width: '100px', render: (_, item) => (<div>DT{item?.id}</div>)},
		{ title: 'Người làm đơn', dataIndex: 'user', key: "user", width: '220px', render: (_, item) => (
			<PopperUserInfo user={item.user}>
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item.user?.avatar} /></div>
					<div>
						<b>{`${item.user?.firstname} ${item.user?.lastname}`}</b>
						<p>{item.user?.username}</p>
					</div>
				</div>
			</PopperUserInfo>
		)},
		{ title: 'Ngày ứng', dataIndex: 'time', key: "time", width: '120px', render: (_, item) => (<p>{renderDate(item?.time)}</p>)},
		{ title: 'Số tiền', dataIndex: 'endDay', key: "endDay", width: '120px', render: (_, item) => (<p>{numberFormat(item?.price)}</p>)},
		{ title: 'Lý do', dataIndex: 'note', key: 'note', width: '220px', render:(_, item) => (<div>{item.note}</div>)},
		{ title: 'Kế toán', dataIndex: 'statusAssign', key: 'statusAssign',width: '150px', render:(_, item) => (
			<StatusLabel pointer small type={item.statusAssign.badge}>{item.statusAssign.label}</StatusLabel>
		)},
		{ title: 'Quản lý', dataIndex: 'statusManager', key: 'statusManager',width: '150px', render:(_, item) => (
			<StatusLabel pointer small type={item.statusManager.badge}>{item.statusManager.label}</StatusLabel>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<FormSalaryAction
				key={item.id}
				item={item}
				onClickEdit={handleEditClick}
				onClickDelete={handleDeleteClick}
				onClickInfo={handleInfoClick}
			/>
		)},
	];

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:550 }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default FormSalaryTable;